import React from 'react';
import { TrendingUp, Eye, Inbox } from 'lucide-react';
import { Card } from './AdminPanelPrimitives';

export const AdminFaqStatsPanel = ({ faqStats, loading }) => {
  const items = faqStats?.items || [];
  const total = faqStats?.total_events || 0;
  const maxOpens = items.length ? items[0].opens : 0;

  return (
    <div style={{ display: 'grid', gap: 14 }}>
      <Card style={{ padding: '18px 22px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <TrendingUp size={22} color="#703FF6" />
          <div>
            <p style={{ margin: 0, fontFamily: "'Outfit', sans-serif", fontSize: 20, fontWeight: 700 }}>
              FAQ Insights
            </p>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#666' }}>
              Anonymous accordion-open events from the in-app Help Center.
              Use this to spot questions that drive the most support load.
            </p>
          </div>
        </div>
        <div
          style={{
            marginTop: 14,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '6px 12px',
            background: '#F6F2FF',
            borderRadius: 999,
            color: '#4A20C9',
            fontWeight: 700,
            fontSize: 13,
          }}
        >
          <Eye size={14} /> {total} total opens
        </div>
      </Card>

      <Card style={{ padding: 0, overflow: 'hidden' }}>
        {loading && (
          <p style={{ padding: 22, textAlign: 'center', color: '#999' }}>
            Loading…
          </p>
        )}
        {!loading && items.length === 0 && (
          <div
            data-testid="admin-faq-stats-empty"
            style={{ padding: 32, textAlign: 'center', color: '#888' }}
          >
            <Inbox size={28} color="#CCC" />
            <p style={{ margin: '10px 0 0', fontSize: 14 }}>
              No FAQ opens yet — they&apos;ll show up here once guests start exploring the Help Center.
            </p>
          </div>
        )}
        {!loading && items.length > 0 && (
          <div style={{ padding: 0 }}>
            {items.map((row, idx) => (
              <div
                key={`${row.category}|${row.question}|${idx}`}
                data-testid={`admin-faq-row-${idx}`}
                style={{
                  padding: '14px 18px',
                  borderTop: idx === 0 ? 'none' : '1px solid #F1F1F1',
                  display: 'grid',
                  gridTemplateColumns: '1fr auto',
                  gap: 12,
                  alignItems: 'center',
                }}
              >
                <div style={{ minWidth: 0 }}>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                      color: '#7A6E96',
                    }}
                  >
                    {row.category}
                  </p>
                  <p
                    style={{
                      margin: '4px 0 0',
                      fontSize: 14.5,
                      fontWeight: 600,
                      color: '#1A1226',
                      lineHeight: 1.35,
                    }}
                  >
                    {row.question}
                  </p>
                  {/* Bar */}
                  <div
                    style={{
                      marginTop: 8,
                      height: 6,
                      background: '#F1ECFF',
                      borderRadius: 999,
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        width: `${Math.max(4, (row.opens / Math.max(1, maxOpens)) * 100)}%`,
                        height: '100%',
                        background:
                          'linear-gradient(90deg, #703FF6 0%, #4A20C9 100%)',
                        borderRadius: 999,
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    fontFamily: "'Outfit', sans-serif",
                    fontSize: 18,
                    fontWeight: 700,
                    color: '#4A20C9',
                    minWidth: 36,
                    textAlign: 'right',
                  }}
                >
                  {row.opens}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};
